import React, { Component } from "react";

import "./AudioVisualiser.css";

export default class AudioVisualiser extends Component {
  constructor(props) {
    super(props);
    this.canvas = React.createRef();
  }

  componentDidUpdate() {
    this.draw();
  }

  draw() {
    const { audioData } = this.props;
    const canvas = this.canvas.current;
    const height = canvas.height;
    const width = canvas.width;
    const context = canvas.getContext("2d");
    let x = 0;
    const sliceWidth = (width * 8.0) / audioData.length;
    context.lineWidth = 5;
    var probabilityChance = Math.floor(Math.random() * 101);
    // context.strokeStyle = "#000000";
    if (probabilityChance > 99) {
      context.strokeStyle =
        "#" + Math.floor(Math.random() * 16777215).toString(16);
    }
    context.clearRect(0, 0, width, height);
    context.beginPath();
    context.moveTo(0, height / 2);
    for (const item of audioData) {
      const y = (item / 255.0) * height;
      context.lineTo(x, y);
      x += sliceWidth;
    }
    context.lineTo(x, height / 2);
    context.stroke();
  }

  render() {
    return (
      <canvas id="audiocanvas" width="600" height="100" ref={this.canvas} />
    );
  }
}
